"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./product-base"));
__export(require("./product-membership"));
__export(require("./product-section"));
__export(require("./product-certificate"));
var ProductType;
(function (ProductType) {
    ProductType["CONFERENCE"] = "conference-type";
    ProductType["PUBLICATION"] = "publication-type";
    ProductType["SUBSCRIPTION"] = "subscription-type";
    ProductType["WEBCAST"] = "webcast-type";
    ProductType["COURSE"] = "online-course-type";
    ProductType["EXAM"] = "exams-type";
    ProductType["DISCONTINUED"] = "discontinued-type";
    ProductType["CONTENT"] = "content-type";
    ProductType["NON_STORE"] = "non-store-type";
    ProductType["ONSITE"] = "onsite-type";
    ProductType["MAGAZINE_SUBSCRIPTION"] = "magazine-subscription";
    ProductType["CPE_DIRECT"] = "cpe-direct";
    ProductType["BUNDLE"] = "bundle-type";
    ProductType["CONTRIBUTION"] = "contribution-type";
    ProductType["CENTER_MEMBERSHIP"] = "center-membership";
    ProductType["MEMBERSHIP"] = "membership-type";
    ProductType["MEMBERSHIP_BENEFIT"] = "membership-benefit";
    ProductType["SECTION"] = "section-type";
    ProductType["CERTIFICATE"] = "certificate-type";
    ProductType["CREDENTIAL"] = "credential-type";
    ProductType["FEE"] = "fee-type";
    ProductType["EXAM_CREDIT"] = "exam-credit-type";
    ProductType["FLP"] = "flp-type";
    ProductType["EVENT"] = "event-type";
    ProductType["KAPLAN"] = "kaplan-type";
    ProductType["ADD_ON"] = "add-on";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ProductSlug;
(function (ProductSlug) {
    ProductSlug["CONFERENCE"] = "conference";
    ProductSlug["PUBLICATION"] = "publication";
    ProductSlug["WEBCAST"] = "webcast";
    ProductSlug["COURSE"] = "course";
    ProductSlug["EXAM"] = "exam";
    ProductSlug["DISCONTINUED"] = "discontinued";
    ProductSlug["CONTENT"] = "content";
    ProductSlug["NON_STORE"] = "non-store";
    ProductSlug["CALENDAR"] = "webcast-conference";
    ProductSlug["CERTIFICATE_PROGRAM"] = "certificate-program";
    ProductSlug["BUNDLE"] = "bundle";
    ProductSlug["CONTRIBUTION"] = "contribution";
    ProductSlug["CENTER_MEMBERSHIP"] = "center-membership";
    ProductSlug["MEMBERSHIP"] = "membership";
    ProductSlug["MEMBERSHIP_BENEFIT"] = "membership-benefit";
    ProductSlug["SECTION"] = "section";
    ProductSlug["CERTIFICATE"] = "certificate";
    ProductSlug["CREDENTIAL"] = "credential";
    ProductSlug["EXAM_CREDIT"] = "exam-credit";
    ProductSlug["EVENT"] = "event";
    ProductSlug["KAPLAN"] = "kaplan";
    ProductSlug["STUDENT_AFFILIATE"] = "aicpa-membership-student-affiliate";
    ProductSlug["FEE"] = "fee-type";
})(ProductSlug = exports.ProductSlug || (exports.ProductSlug = {}));
var ProductTypeLabels;
(function (ProductTypeLabels) {
    ProductTypeLabels["CONFERENCE"] = "Conference";
    ProductTypeLabels["PUBLICATION"] = "Publication";
    ProductTypeLabels["WEBCAST"] = "Webcast";
    ProductTypeLabels["CONTENT"] = "Content";
    ProductTypeLabels["COURSE"] = "CPE Self-study";
    ProductTypeLabels["EXAM"] = "Exam";
    ProductTypeLabels["MAGAZINE_SUBSCRIPTION"] = "Magazine Subscription";
    ProductTypeLabels["CPE_DIRECT"] = "CPE direct";
    ProductTypeLabels["BUNDLE"] = "Bundle";
    ProductTypeLabels["CONTRIBUTION"] = "Contribution";
    ProductTypeLabels["CENTER_MEMBERSHIP"] = "Center Membership";
    ProductTypeLabels["MEMBERSHIP"] = "Membership";
    ProductTypeLabels["MEMBERSHIP_BENEFIT"] = "Membership Benefit";
    ProductTypeLabels["SECTION"] = "Section";
    ProductTypeLabels["CERTIFICATE"] = "Certificate";
    ProductTypeLabels["CREDENTIAL"] = "Credential";
    ProductTypeLabels["EXAM_CREDIT"] = "Exam Credit";
    ProductTypeLabels["EVENT"] = "Event";
    ProductTypeLabels["KAPLAN"] = "Kaplan";
    ProductTypeLabels["FLP"] = "FLP";
})(ProductTypeLabels = exports.ProductTypeLabels || (exports.ProductTypeLabels = {}));
var ProductCurrencyLabel;
(function (ProductCurrencyLabel) {
    ProductCurrencyLabel["USD"] = "USD";
    ProductCurrencyLabel["GBP"] = "GBP";
    ProductCurrencyLabel["EUR"] = "EUR";
})(ProductCurrencyLabel = exports.ProductCurrencyLabel || (exports.ProductCurrencyLabel = {}));
var ProductCurrencySign;
(function (ProductCurrencySign) {
    ProductCurrencySign["DOLLAR"] = "$";
    ProductCurrencySign["POUND"] = "\u00A3";
    ProductCurrencySign["EURO"] = "\u20AC";
})(ProductCurrencySign = exports.ProductCurrencySign || (exports.ProductCurrencySign = {}));
exports.PRODUCT_CURRENCY_OPTIONS = [
    { text: 'US dollars ($)', value: ProductCurrencyLabel.USD, key: ProductCurrencySign.DOLLAR },
    { text: 'British pounds (£)', value: ProductCurrencyLabel.GBP, key: ProductCurrencySign.POUND },
];
exports.ProductsCurrencyItems = [
    {
        key: ProductCurrencyLabel.USD,
        label: ProductCurrencyLabel.USD,
        sign: ProductCurrencySign.DOLLAR,
    },
    {
        key: ProductCurrencyLabel.GBP,
        label: ProductCurrencyLabel.GBP,
        sign: ProductCurrencySign.POUND,
    },
    {
        key: ProductCurrencyLabel.EUR,
        label: ProductCurrencyLabel.EUR,
        sign: ProductCurrencySign.EURO,
    },
];
exports.ProductTypesSlugsMap = {
    [ProductType.CONFERENCE]: ProductSlug.CONFERENCE,
    [ProductType.PUBLICATION]: ProductSlug.PUBLICATION,
    [ProductType.WEBCAST]: ProductSlug.WEBCAST,
    [ProductType.COURSE]: ProductSlug.COURSE,
    [ProductType.EXAM]: ProductSlug.EXAM,
    [ProductType.CONTENT]: ProductSlug.CONTENT,
    [ProductType.BUNDLE]: ProductSlug.BUNDLE,
    [ProductType.CENTER_MEMBERSHIP]: ProductSlug.CENTER_MEMBERSHIP,
    [ProductType.MEMBERSHIP]: ProductSlug.MEMBERSHIP,
    [ProductType.MEMBERSHIP_BENEFIT]: ProductSlug.MEMBERSHIP_BENEFIT,
    [ProductType.SECTION]: ProductSlug.SECTION,
    [ProductType.CERTIFICATE]: ProductSlug.CERTIFICATE,
    [ProductType.CREDENTIAL]: ProductSlug.CREDENTIAL,
    [ProductType.EXAM_CREDIT]: ProductSlug.EXAM_CREDIT,
    [ProductType.EVENT]: ProductSlug.EVENT,
    [ProductType.KAPLAN]: ProductSlug.KAPLAN,
    [ProductType.FEE]: ProductSlug.FEE,
};
exports.ProductSlugsTypesMap = {
    [ProductSlug.CONFERENCE]: ProductType.CONFERENCE,
    [ProductSlug.PUBLICATION]: ProductType.PUBLICATION,
    [ProductSlug.WEBCAST]: ProductType.WEBCAST,
    [ProductSlug.COURSE]: ProductType.COURSE,
    [ProductSlug.EXAM]: ProductType.EXAM,
    [ProductSlug.CONTENT]: ProductType.CONTENT,
    [ProductSlug.BUNDLE]: ProductType.BUNDLE,
    [ProductSlug.CONTRIBUTION]: ProductType.CONTRIBUTION,
    [ProductSlug.CENTER_MEMBERSHIP]: ProductType.CENTER_MEMBERSHIP,
    [ProductSlug.MEMBERSHIP]: ProductType.MEMBERSHIP,
    [ProductSlug.MEMBERSHIP_BENEFIT]: ProductType.MEMBERSHIP_BENEFIT,
    [ProductSlug.SECTION]: ProductType.SECTION,
    [ProductSlug.CERTIFICATE]: ProductType.CERTIFICATE,
    [ProductSlug.CREDENTIAL]: ProductType.CREDENTIAL,
    [ProductSlug.EXAM_CREDIT]: ProductType.EXAM_CREDIT,
    [ProductSlug.EVENT]: ProductType.EVENT,
    [ProductSlug.KAPLAN]: ProductType.KAPLAN,
};
exports.DonationTypesSlugsMap = {
    [ProductType.CONTRIBUTION]: ProductSlug.CONTRIBUTION,
};
// CT subscription-type synthetic type, use subscriptionProductType field to define real product type
var SubscriptionProductType;
(function (SubscriptionProductType) {
    SubscriptionProductType["WEBCAST"] = "webcast";
    SubscriptionProductType["COURSE"] = "course";
    SubscriptionProductType["PUBLICATION"] = "publication";
    SubscriptionProductType["CONTENT"] = "content";
    SubscriptionProductType["MAGAZINE_SUBSCRIPTION"] = "Magazine Subscription";
})(SubscriptionProductType = exports.SubscriptionProductType || (exports.SubscriptionProductType = {}));
exports.SUBSCRIPTION_PRODUCT_TYPE_NAMES = {
    [SubscriptionProductType.MAGAZINE_SUBSCRIPTION]: ProductTypeLabels.MAGAZINE_SUBSCRIPTION,
    [SubscriptionProductType.COURSE]: ProductTypeLabels.COURSE,
    [SubscriptionProductType.WEBCAST]: ProductTypeLabels.WEBCAST,
    [SubscriptionProductType.CONTENT]: ProductTypeLabels.CONTENT,
    [SubscriptionProductType.PUBLICATION]: ProductTypeLabels.PUBLICATION,
};
exports.PRODUCT_TYPES_NAMES = {
    [ProductType.CONFERENCE]: ProductTypeLabels.CONFERENCE,
    [ProductType.PUBLICATION]: ProductTypeLabels.PUBLICATION,
    [ProductType.SUBSCRIPTION]: 'Subscription',
    [ProductType.WEBCAST]: ProductTypeLabels.WEBCAST,
    [ProductType.COURSE]: ProductTypeLabels.COURSE,
    [ProductType.EXAM]: ProductTypeLabels.EXAM,
    [ProductType.MAGAZINE_SUBSCRIPTION]: ProductTypeLabels.MAGAZINE_SUBSCRIPTION,
    [ProductType.CPE_DIRECT]: ProductTypeLabels.CPE_DIRECT,
    [ProductType.BUNDLE]: ProductTypeLabels.BUNDLE,
    [ProductType.CONTRIBUTION]: ProductTypeLabels.CONTRIBUTION,
    [ProductType.CENTER_MEMBERSHIP]: ProductTypeLabels.CENTER_MEMBERSHIP,
    [ProductType.MEMBERSHIP]: ProductTypeLabels.MEMBERSHIP,
    [ProductType.MEMBERSHIP_BENEFIT]: ProductTypeLabels.MEMBERSHIP_BENEFIT,
    [ProductType.SECTION]: ProductTypeLabels.SECTION,
    [ProductType.CERTIFICATE]: ProductTypeLabels.CERTIFICATE,
    [ProductType.CREDENTIAL]: ProductTypeLabels.CREDENTIAL,
    [ProductType.EXAM_CREDIT]: ProductTypeLabels.EXAM_CREDIT,
    [ProductType.EVENT]: ProductTypeLabels.EVENT,
};
var AvailableFormat;
(function (AvailableFormat) {
    AvailableFormat["ONLINE"] = "online";
    AvailableFormat["ONLINE_EXAM"] = "online+exam";
    AvailableFormat["EXAM"] = "exam";
    AvailableFormat["FLEX_PASS"] = "flex-pass";
    AvailableFormat["EBOOK"] = "e-book";
    AvailableFormat["PAPERBACK"] = "paperback";
    AvailableFormat["HARDCOVER"] = "hardcover";
    AvailableFormat["ONSITE"] = "onsite";
    AvailableFormat["EXAM_KRYTERION"] = "exam-kryterion";
    AvailableFormat["EXAM_RETAKE_KRYTERION"] = "exam-retake-kryterion";
    AvailableFormat["EXAM_PART1_KRYTERION"] = "exam-part-1-kryterion";
    AvailableFormat["EXAM_PART2_KRYTERION"] = "exam-part-2-kryterion";
    AvailableFormat["EXAM_RETAKE_PART1_KRYTERION"] = "exam-retake-part-1-kryterion";
    AvailableFormat["EXAM_RETAKE_PART2_KRYTERION"] = "exam-retake-part-2-kryterion";
    AvailableFormat["FLEX_PASS_CONFERENCE"] = "flex-pass-conference";
    AvailableFormat["ONLINE_CONFERENCE"] = "online-conference";
    AvailableFormat["ONSITE_CONFERENCE"] = "onsite-conference";
    AvailableFormat["SUBSCRIPTION"] = "subscription";
    AvailableFormat["TEXT"] = "text";
    AvailableFormat["ON_DEMAND"] = "on-demand";
    AvailableFormat["SCHEDULED"] = "scheduled";
    AvailableFormat["WEBCAST"] = "webcast";
    AvailableFormat["SERIES"] = "series";
    AvailableFormat["MULTI_DAY"] = "multi-day";
    AvailableFormat["MULTIPLE"] = "multiple";
    AvailableFormat["CPE_SELF_STUDY"] = "CPE Self-Study";
    AvailableFormat["MAGAZINE_SUBSCRIPTION"] = "Magazine subscription";
})(AvailableFormat = exports.AvailableFormat || (exports.AvailableFormat = {}));
// this is a separate enum as the discontinued types have a different setup to other product types within RAVE platform
var DiscontinuedProductFormat;
(function (DiscontinuedProductFormat) {
    DiscontinuedProductFormat["PUBLICATION_EBOOK"] = "e-book";
    DiscontinuedProductFormat["PUBLICATION_PAPERBACK"] = "paperback";
    DiscontinuedProductFormat["PUBLICATION_HARDCOVER"] = "hardcover";
    DiscontinuedProductFormat["PUBLICATION_SUBSCRIPTION"] = "publication-subscription";
    DiscontinuedProductFormat["CONFERENCE_FLEX_PASS"] = "flex-pass-conference";
    DiscontinuedProductFormat["CONFERENCE_ONLINE"] = "online-conference";
    DiscontinuedProductFormat["CONFERENCE_ONSITE"] = "onsite-conference";
    DiscontinuedProductFormat["COURSE_ONLINE"] = "online";
    DiscontinuedProductFormat["COURSE_ONLINE_EXAM"] = "online+exam";
    DiscontinuedProductFormat["COURSE_SUBSCRIPTION"] = "subscription";
    DiscontinuedProductFormat["COURSE_TEXT"] = "text";
    DiscontinuedProductFormat["EXAM_ON_DEMAND"] = "exam-on-demand";
    DiscontinuedProductFormat["EXAM_PROCTORED"] = "exam-proctored";
    DiscontinuedProductFormat["WEBCAST"] = "webcast";
    DiscontinuedProductFormat["WEBCAST_MULTI_DAY"] = "multi-day-webcast";
    DiscontinuedProductFormat["WEBCAST_SERIES"] = "series-webcast";
    DiscontinuedProductFormat["WEBCAST_SUBSCRIPTION"] = "subscription-webcast";
})(DiscontinuedProductFormat = exports.DiscontinuedProductFormat || (exports.DiscontinuedProductFormat = {}));
var NonStoreFormat;
(function (NonStoreFormat) {
    NonStoreFormat["SHIPPING_FEE_ONE_TIME"] = "shipping-fee-one-time";
    NonStoreFormat["MANUAL_PRODUCT_RECURRING"] = "manual-product-recurring";
    NonStoreFormat["MANUAL_PRODUCT_ONE_TIME"] = "manual-product-one-time";
})(NonStoreFormat = exports.NonStoreFormat || (exports.NonStoreFormat = {}));
// this is used client side to map available formats into front-end friendly text
exports.AVAILABLE_FORMAT_NAMES = {
    [AvailableFormat.ONLINE]: 'Online',
    [AvailableFormat.ONLINE_EXAM]: 'Online + Exam',
    [AvailableFormat.EXAM]: 'Exam',
    [AvailableFormat.FLEX_PASS]: 'Flex Pass',
    [AvailableFormat.EBOOK]: 'E-Book',
    [AvailableFormat.PAPERBACK]: 'Paperback',
    [AvailableFormat.HARDCOVER]: 'Hardcover',
    [AvailableFormat.ONSITE]: 'In person',
    [AvailableFormat.EXAM_KRYTERION]: 'Exam',
    [AvailableFormat.EXAM_RETAKE_KRYTERION]: 'Exam Retake',
    [AvailableFormat.EXAM_PART1_KRYTERION]: 'Exam Part 1',
    [AvailableFormat.EXAM_PART2_KRYTERION]: 'Exam Part 2',
    [AvailableFormat.EXAM_RETAKE_PART1_KRYTERION]: 'Exam Retake, Part 1',
    [AvailableFormat.EXAM_RETAKE_PART2_KRYTERION]: 'Exam Retake, Part 2',
    [AvailableFormat.FLEX_PASS_CONFERENCE]: 'Flex Pass',
    [AvailableFormat.ONLINE_CONFERENCE]: 'Live Online',
    [AvailableFormat.ONSITE_CONFERENCE]: 'Onsite',
    [AvailableFormat.SUBSCRIPTION]: 'Online subscription',
    [AvailableFormat.TEXT]: 'Text',
    [AvailableFormat.SCHEDULED]: 'Scheduled',
    [AvailableFormat.ON_DEMAND]: 'On-demand',
    [AvailableFormat.WEBCAST]: 'Webcast',
    [AvailableFormat.SERIES]: 'Series',
    [AvailableFormat.MULTI_DAY]: 'Multi-day',
    [AvailableFormat.MULTIPLE]: 'Multiple',
};
// this is used client side to map the discontinued available formats into front-end friendly text
exports.DISCONTINUED_AVAILABLE_FORMAT_NAMES = {
    [DiscontinuedProductFormat.WEBCAST]: 'Webcast',
    [DiscontinuedProductFormat.WEBCAST_MULTI_DAY]: 'Webcast',
    [DiscontinuedProductFormat.WEBCAST_SERIES]: 'Webcast',
    [DiscontinuedProductFormat.WEBCAST_SUBSCRIPTION]: 'Webcast',
    [DiscontinuedProductFormat.PUBLICATION_EBOOK]: 'E-book',
    [DiscontinuedProductFormat.PUBLICATION_PAPERBACK]: 'Paperback',
    [DiscontinuedProductFormat.PUBLICATION_HARDCOVER]: 'Hardcover',
    [DiscontinuedProductFormat.PUBLICATION_SUBSCRIPTION]: 'Online subscription',
    [DiscontinuedProductFormat.CONFERENCE_FLEX_PASS]: 'Conference: Flex Pass',
    [DiscontinuedProductFormat.CONFERENCE_ONLINE]: 'Conference: Online',
    [DiscontinuedProductFormat.CONFERENCE_ONSITE]: 'Conference: Onsite',
    [DiscontinuedProductFormat.COURSE_ONLINE]: 'Online course',
    [DiscontinuedProductFormat.COURSE_ONLINE_EXAM]: 'Online course + exam',
    [DiscontinuedProductFormat.COURSE_SUBSCRIPTION]: 'Online course',
    [DiscontinuedProductFormat.COURSE_TEXT]: 'Online course',
    [DiscontinuedProductFormat.EXAM_ON_DEMAND]: 'On-demand',
    [DiscontinuedProductFormat.EXAM_PROCTORED]: 'Proctored',
};
// this is used in mxp-search-service, elasticsearch lambdas
// if a product type isnt in here then it's no searchable
exports.SearchableProductTypes = {
    [ProductSlug.PUBLICATION]: {
        key: ProductType.PUBLICATION,
        label: ProductTypeLabels.PUBLICATION,
        availableFormat: [
            AvailableFormat.EBOOK,
            AvailableFormat.PAPERBACK,
            AvailableFormat.HARDCOVER,
            AvailableFormat.SUBSCRIPTION,
        ],
    },
    [ProductSlug.COURSE]: {
        key: ProductType.COURSE,
        label: ProductTypeLabels.COURSE,
        availableFormat: [
            AvailableFormat.ONLINE,
            AvailableFormat.ONLINE_EXAM.replace('+e', 'E'),
            AvailableFormat.TEXT,
            AvailableFormat.SUBSCRIPTION,
        ],
    },
    [ProductSlug.WEBCAST]: {
        key: ProductType.WEBCAST,
        label: ProductTypeLabels.WEBCAST,
        availableFormat: [AvailableFormat.SUBSCRIPTION],
    },
    [ProductSlug.CONFERENCE]: {
        key: ProductType.CONFERENCE,
        label: ProductTypeLabels.CONFERENCE,
        availableFormat: [
            AvailableFormat.ONSITE_CONFERENCE,
            AvailableFormat.FLEX_PASS_CONFERENCE,
            AvailableFormat.ONLINE_CONFERENCE,
        ],
    },
    [ProductSlug.EXAM]: {
        key: ProductType.EXAM,
        label: ProductTypeLabels.EXAM,
        availableFormat: [AvailableFormat.SCHEDULED, AvailableFormat.ON_DEMAND],
    },
    [ProductSlug.CONTENT]: {
        key: ProductType.CONTENT,
        label: ProductTypeLabels.CONTENT,
        availableFormat: [],
    },
    [ProductSlug.BUNDLE]: {
        key: ProductType.BUNDLE,
        label: ProductTypeLabels.BUNDLE,
        availableFormat: [AvailableFormat.MULTIPLE],
    },
    [ProductSlug.CONTRIBUTION]: {
        key: ProductType.CONTRIBUTION,
        label: ProductTypeLabels.CONTRIBUTION,
        availableFormat: [],
    },
    [ProductSlug.CERTIFICATE]: {
        key: ProductType.CERTIFICATE,
        label: ProductTypeLabels.CERTIFICATE,
        availableFormat: [],
    },
    [ProductSlug.EXAM_CREDIT]: {
        key: ProductType.EXAM_CREDIT,
        label: ProductTypeLabels.EXAM_CREDIT,
        availableFormat: [],
    },
    [ProductSlug.EVENT]: {
        key: ProductType.EVENT,
        label: ProductTypeLabels.EVENT,
        availableFormat: [],
    },
    [ProductSlug.KAPLAN]: {
        key: ProductType.KAPLAN,
        label: ProductTypeLabels.KAPLAN,
        availableFormat: [],
    },
};
var ZuoraSubscriptionStatus;
(function (ZuoraSubscriptionStatus) {
    ZuoraSubscriptionStatus["DRAFT"] = "Draft";
    ZuoraSubscriptionStatus["PENDING_ACTIVATION"] = "Pending Activation";
    ZuoraSubscriptionStatus["PENDING_ACCEPTANCE"] = "Pending Acceptance";
    ZuoraSubscriptionStatus["ACTIVE"] = "Active";
    ZuoraSubscriptionStatus["CANCELLED"] = "Cancelled";
    ZuoraSubscriptionStatus["EXPIRED"] = "Expired";
    ZuoraSubscriptionStatus["SUSPENDED"] = "Suspended";
})(ZuoraSubscriptionStatus = exports.ZuoraSubscriptionStatus || (exports.ZuoraSubscriptionStatus = {}));
var DonationAttestation;
(function (DonationAttestation) {
    DonationAttestation["YES"] = "yes";
    DonationAttestation["NO"] = "no";
    DonationAttestation["NOTAVAILABLE"] = "na";
})(DonationAttestation = exports.DonationAttestation || (exports.DonationAttestation = {}));
var DonationCardType;
(function (DonationCardType) {
    DonationCardType["PERSONAL"] = "Personal";
    DonationCardType["CORPORATE"] = "Corporate";
})(DonationCardType = exports.DonationCardType || (exports.DonationCardType = {}));
var DonationCustomFields;
(function (DonationCustomFields) {
    DonationCustomFields["ATTESTATION_REQUIRED"] = "attestationRequired";
})(DonationCustomFields = exports.DonationCustomFields || (exports.DonationCustomFields = {}));
var SubscriptionRenewalStage;
(function (SubscriptionRenewalStage) {
    SubscriptionRenewalStage["PRE_RENEWAL_30_DAYS"] = "30-days";
    SubscriptionRenewalStage["PRE_RENEWAL_7_DAYS"] = "7-days";
    SubscriptionRenewalStage["RENEWAL"] = "renewal";
    SubscriptionRenewalStage["GRACE_PERIOD"] = "grace-period";
    SubscriptionRenewalStage["END_OF_TERM"] = "end-of-term";
    SubscriptionRenewalStage["FT_PRE_RENEWAL_7_DAYS"] = "ft-7-days";
    SubscriptionRenewalStage["FT_RENEWAL"] = "ft-renewal";
    SubscriptionRenewalStage["FT_END_OF_TERM"] = "ft-end-of-term";
})(SubscriptionRenewalStage = exports.SubscriptionRenewalStage || (exports.SubscriptionRenewalStage = {}));
var Fee;
(function (Fee) {
    Fee["AICPA_JOINING_FEE"] = "aicpa-membership-enrollment-fee";
    Fee["AICPA_LATE_FEE"] = "aicpa-membership-renewal-late-fee";
    Fee["CIMA_JOINING_FEE"] = "cima-membership-enrollment-fee";
    Fee["CIMA_LATE_FEE"] = "cima-membership-renewal-late-fee";
    Fee["CIMA_RE_REGISTRATION_FEE"] = "cima-re-registration-fee";
    // Rejoining Fees
    Fee["CIMA_REJOINING_FEE_CANDIDATE"] = "rejoining-fee-cima-candidate";
    Fee["CIMA_REJOINING_FEE_CGMA_AFFILIATE"] = "rejoining-fee-cima-cgma-affiliate";
    Fee["CIMA_REJOINING_FEE_AFFILIATE"] = "rejoining-fee-cima-affiliate";
    Fee["CIMA_REJOINING_FEE_REGULAR"] = "rejoining-fee-cima-regular";
    Fee["CIMA_REJOINING_FEE_RETIRED"] = "rejoining-fee-cima-retired";
    Fee["FLP_REJOINING_FEE"] = "rejoining-fee-flp";
    Fee["FCMA_REJOINING_FEE"] = "rejoining-fee-fcma-credential";
    Fee["AICPA_REJOINING_FEE_CANDIDATE"] = "rejoining-fee-aicpa-candidate";
    Fee["AICPA_REJOINING_FEE_AFFILIATE"] = "rejoining-fee-aicpa-affiliate";
    Fee["AICPA_REJOINING_FEE_REGULAR"] = "rejoining-fee-aicpa-regular";
    Fee["AICPA_REJOINING_FEE_RETIRED"] = "rejoining-fee-aicpa-retired";
    Fee["AICPA_REJOINING_FEE_STUDENT_AFFILIATE"] = "rejoining-fee-aicpa-student-affiliate";
    Fee["AICPA_REJOINING_FEE_INTERNATIONAL"] = "rejoining-fee-aicpa-international";
    Fee["FCMA_APPLICATION_FEE"] = "application-fee-fcma";
    Fee["CIMA_APPLICATION_FEE"] = "application-fee";
})(Fee = exports.Fee || (exports.Fee = {}));
exports.RefundOrCancellationRequiredActions = [
    {
        key: 1,
        text: 'Refund with cancellation',
        value: 'Refund-with-cancellation',
    },
    {
        key: 2,
        text: 'Refund without cancellation',
        value: 'Refund-without-cancellation',
    },
    {
        key: 3,
        text: 'Cancel only',
        value: 'Cancel-only',
    },
    {
        key: 4,
        text: 'Cancel and move',
        value: 'Cancel-and-move',
    },
];
exports.RefundOrCancellationReasons = [
    {
        key: 1,
        text: 'Cancellation',
        value: 'Cancellation',
    },
    {
        key: 2,
        text: 'Cancelled Dues',
        value: 'Cancelled Dues',
    },
    {
        key: 3,
        text: 'Cancelled Sec/Cred',
        value: 'Cancelled Sec/Cred',
    },
    {
        key: 4,
        text: 'Cancelled Product',
        value: 'Cancelled Product',
    },
    {
        key: 5,
        text: 'Cancelled Event',
        value: 'Cancelled Event',
    },
    {
        key: 6,
        text: 'Other',
        value: 'Other',
    },
    {
        key: 7,
        text: 'Cust. service exception',
        value: 'Cust. service exception',
    },
    {
        key: 8,
        text: 'Gratis',
        value: 'Gratis',
    },
    {
        key: 9,
        text: 'Disc Not Received',
        value: 'Disc Not Received',
    },
    {
        key: 10,
        text: 'Credit & Rebilled',
        value: 'Credit & Rebilled',
    },
];
exports.RefundOrCancellationTypeOfCancellation = [
    {
        key: 1,
        text: 'Termination',
        value: 'Termination',
    },
    {
        key: 2,
        text: 'Resignation',
        value: 'Resignation',
    },
];
exports.RefundOrCancellationTerminationReason = [
    {
        key: 1,
        text: 'Expelled - Disciplinary',
        value: 'Expelled - Disciplinary',
    },
    {
        key: 2,
        text: 'Peer Review non-compliance',
        value: 'Peer Review non-compliance',
    },
    {
        key: 3,
        text: 'Other - see notes',
        value: 'Other - see notes',
    },
];
exports.RefundOrCancellationResignationReason = [
    {
        key: 1,
        text: 'Too expensive / Cost',
        value: 'Too expensive / Cost',
    },
    {
        key: 2,
        text: 'Resources or Credential no longer valuable or relevant',
        value: 'Resources or Credential no longer valuable or relevant',
    },
    {
        key: 3,
        text: 'My employer no longer pays',
        value: 'My employer no longer pays',
    },
    {
        key: 4,
        text: 'Membership Requirements Compliance',
        value: 'Membership Requirements Compliance',
    },
    {
        key: 5,
        text: 'Financial/Personal Hardship',
        value: 'Financial/Personal Hardship',
    },
    {
        key: 6,
        text: 'Left practice area',
        value: 'Left practice area',
    },
    {
        key: 7,
        text: 'Retired/semi-retired',
        value: 'Retired/semi-retired',
    },
    {
        key: 8,
        text: 'Other - see notes',
        value: 'Other - see notes',
    },
];
var RefundOrCancellationTypeOfCancellationEnums;
(function (RefundOrCancellationTypeOfCancellationEnums) {
    RefundOrCancellationTypeOfCancellationEnums["TERMINATION"] = "Termination";
    RefundOrCancellationTypeOfCancellationEnums["RESIGNATION"] = "Resignation";
})(RefundOrCancellationTypeOfCancellationEnums = exports.RefundOrCancellationTypeOfCancellationEnums || (exports.RefundOrCancellationTypeOfCancellationEnums = {}));
var ProductEthicStatus;
(function (ProductEthicStatus) {
    ProductEthicStatus["UNDER_INVESTIGATION"] = "Under Investigation";
    ProductEthicStatus["SUSPENDED"] = "Suspended";
    ProductEthicStatus["REMEDIATION"] = "Remediation";
    ProductEthicStatus["SANCTIONED"] = "Sanctioned";
})(ProductEthicStatus = exports.ProductEthicStatus || (exports.ProductEthicStatus = {}));
var MembershipApplicationType;
(function (MembershipApplicationType) {
    MembershipApplicationType["AICPA"] = "aicpa";
    MembershipApplicationType["CIMA"] = "cima";
    MembershipApplicationType["AICPA_CENTER_MEMBERSHIP"] = "aicpa_center_membership";
    MembershipApplicationType["CIMA_MIP"] = "cima_mip";
    MembershipApplicationType["CIMA_FLP"] = "cima_flp";
})(MembershipApplicationType = exports.MembershipApplicationType || (exports.MembershipApplicationType = {}));
var RefundOrCancellationEnums;
(function (RefundOrCancellationEnums) {
    RefundOrCancellationEnums["REFUND_WITH_CANCELLATION"] = "Refund-with-cancellation";
    RefundOrCancellationEnums["REFUND_WITHOUT_CANCELLATION"] = "Refund-without-cancellation";
    RefundOrCancellationEnums["CANCEL_ONLY"] = "Cancel-only";
    RefundOrCancellationEnums["CANCEL_AND_MOVE"] = "Cancel-and-move";
    RefundOrCancellationEnums["PARTIAL_REFUND_WITH_CANCELLATION"] = "Partial-refund-with-cancellation";
})(RefundOrCancellationEnums = exports.RefundOrCancellationEnums || (exports.RefundOrCancellationEnums = {}));
var ProductMembershipBody;
(function (ProductMembershipBody) {
    ProductMembershipBody["AICPA"] = "aicpa";
    ProductMembershipBody["CIMA"] = "cima";
})(ProductMembershipBody = exports.ProductMembershipBody || (exports.ProductMembershipBody = {}));
var SectionProductSKU;
(function (SectionProductSKU) {
    SectionProductSKU["TAX"] = "SECTAX";
    SectionProductSKU["FVS"] = "SECFVS";
    SectionProductSKU["NFP"] = "SECNFP";
    SectionProductSKU["PFP"] = "SECPFP";
})(SectionProductSKU = exports.SectionProductSKU || (exports.SectionProductSKU = {}));
var CredentialProductSlug;
(function (CredentialProductSlug) {
    CredentialProductSlug["PFS"] = "pfs-credential";
    CredentialProductSlug["CFF"] = "cff-credential";
    CredentialProductSlug["ABV"] = "abv-credential";
    CredentialProductSlug["CITP"] = "citp-credential";
    CredentialProductSlug["CVFI"] = "cvfi-credential";
    CredentialProductSlug["CEIV"] = "ceiv-credential";
    CredentialProductSlug["CGMA"] = "cgma-designation";
    CredentialProductSlug["FCMA"] = "cima-fcma";
    CredentialProductSlug["MIP"] = "cima-membership-in-practice";
})(CredentialProductSlug = exports.CredentialProductSlug || (exports.CredentialProductSlug = {}));
var CentersMembershipProductSlug;
(function (CentersMembershipProductSlug) {
    CentersMembershipProductSlug["CAQ"] = "caq";
    CentersMembershipProductSlug["GAQC"] = "gaqc";
    CentersMembershipProductSlug["CPEA"] = "cpea";
    CentersMembershipProductSlug["EBPAQC"] = "ebpaqc";
    CentersMembershipProductSlug["PCPS"] = "pcps";
})(CentersMembershipProductSlug = exports.CentersMembershipProductSlug || (exports.CentersMembershipProductSlug = {}));
var CredentialKey;
(function (CredentialKey) {
    CredentialKey["FCMA"] = "FCMA";
    CredentialKey["MIP"] = "MIP";
    CredentialKey["ACMA"] = "ACMA";
    CredentialKey["MIP_RENEWAL"] = "MIP Renewal";
    CredentialKey["CIMA_MIP"] = "CIMA Membership in Practice";
    CredentialKey["CGMA"] = "CGMA";
})(CredentialKey = exports.CredentialKey || (exports.CredentialKey = {}));
var CIMA_CREDENTIALS_SKU;
(function (CIMA_CREDENTIALS_SKU) {
    CIMA_CREDENTIALS_SKU["ACMA"] = "CIMAACMA01";
    CIMA_CREDENTIALS_SKU["CGMA"] = "CIMACGMA01";
    CIMA_CREDENTIALS_SKU["FCMA"] = "CIMAFCMA01";
})(CIMA_CREDENTIALS_SKU = exports.CIMA_CREDENTIALS_SKU || (exports.CIMA_CREDENTIALS_SKU = {}));
var CimaMembershipSkus;
(function (CimaMembershipSkus) {
    CimaMembershipSkus["REGULAR"] = "CIMAMEMREGC22";
    CimaMembershipSkus["RETIRED"] = "CIMAMEMRETNVR22";
})(CimaMembershipSkus = exports.CimaMembershipSkus || (exports.CimaMembershipSkus = {}));
exports.CimaCredentialName = {
    [CIMA_CREDENTIALS_SKU.ACMA]: 'CIMA ACMA',
    [CIMA_CREDENTIALS_SKU.CGMA]: 'CIMA CGMA',
};
exports.CimaCredentialProductLink = {
    [CIMA_CREDENTIALS_SKU.ACMA]: 'cima-acma',
    [CIMA_CREDENTIALS_SKU.CGMA]: 'cima-cgma',
};
exports.FCMAProductSlug = 'cima-fcma';
var ProductTypeFee;
(function (ProductTypeFee) {
    ProductTypeFee["AICPA_MEMBERSHIP_RENEWAL_LATE_FEE"] = "MEM-FEE-LATE";
    ProductTypeFee["AICPA_MEMBERSHIP_ENROLLMENT_FEE"] = "MEM-FEE-ENR";
    ProductTypeFee["CIMA_MEMBERSHIP_RENEWAL_LATE_FEE"] = "CIMA-MEM-FEE-LATE";
    ProductTypeFee["CIMA_MEMBERSHIP_ENROLLMENT_FEE"] = "CIMA-MEM-FEE-ENR";
    ProductTypeFee["APPLICATION_FEE"] = "APPLICATION_FEE";
    ProductTypeFee["PROGRAM_FEE"] = "PROGRAM_FEE";
    ProductTypeFee["REJOINING_FEE_CIMA_CANDIDATE"] = "CIMA-MEM_CANDIDAET-FEE-REJOINING";
})(ProductTypeFee = exports.ProductTypeFee || (exports.ProductTypeFee = {}));
var ProductStatusProperties;
(function (ProductStatusProperties) {
    ProductStatusProperties["MEMBERSHIP"] = "SFS_MEM_Status__c";
    ProductStatusProperties["SECTION"] = "SFS_SEC_Status__c";
    ProductStatusProperties["CREDENTIAL"] = "SFS_CRE_Status__c";
})(ProductStatusProperties = exports.ProductStatusProperties || (exports.ProductStatusProperties = {}));
var ProductCancellationStatus;
(function (ProductCancellationStatus) {
    ProductCancellationStatus["RESIGNED"] = "Resigned";
    ProductCancellationStatus["TERMINATED"] = "Terminated";
})(ProductCancellationStatus = exports.ProductCancellationStatus || (exports.ProductCancellationStatus = {}));
var ProductEndDateProperties;
(function (ProductEndDateProperties) {
    ProductEndDateProperties["MEMBERSHIP"] = "SFS_MEM_EndDate__c";
    ProductEndDateProperties["SECTION"] = "SFS_SEC_EndDate__c";
    ProductEndDateProperties["CREDENTIAL"] = "SFS_CRE_EndDate__c";
})(ProductEndDateProperties = exports.ProductEndDateProperties || (exports.ProductEndDateProperties = {}));
var ProductCommentsProperties;
(function (ProductCommentsProperties) {
    ProductCommentsProperties["MEMBERSHIP"] = "SFS_MEM_TerminationComments__c";
    ProductCommentsProperties["SECTION"] = "SFS_SEC_TerminationComments__c";
    ProductCommentsProperties["CREDENTIAL"] = "SFS_CRE_TerminationComments__c";
})(ProductCommentsProperties = exports.ProductCommentsProperties || (exports.ProductCommentsProperties = {}));
var ProductReasonProperties;
(function (ProductReasonProperties) {
    ProductReasonProperties["MEMBERSHIP"] = "SFS_MEM_TerminationReason__c";
    ProductReasonProperties["SECTION"] = "SFS_SEC_TerminationReason__c";
    ProductReasonProperties["CREDENTIAL"] = "SFS_CRE_TerminationReason__c";
})(ProductReasonProperties = exports.ProductReasonProperties || (exports.ProductReasonProperties = {}));
var FullEntityName;
(function (FullEntityName) {
    FullEntityName["AICPA"] = "The Association of International of Certified Professional Accountants";
    FullEntityName["CIMA"] = "The Chartered Institute of Management Accountants";
})(FullEntityName = exports.FullEntityName || (exports.FullEntityName = {}));
var FLPSubscriptions;
(function (FLPSubscriptions) {
    FLPSubscriptions["FLP_SKILLS_PREMIUM"] = "FLP - Skills Premium";
    FLPSubscriptions["SKILLS_PREMIUM"] = "Skills Premium";
    FLPSubscriptions["UNIVERSITY_CORE"] = "University Core";
    FLPSubscriptions["UNIVERSITY_SKILLS_CORE"] = "University Skills Core";
})(FLPSubscriptions = exports.FLPSubscriptions || (exports.FLPSubscriptions = {}));
var CPAFLPMembershipTierSkus;
(function (CPAFLPMembershipTierSkus) {
    CPAFLPMembershipTierSkus["STAFFCORE"] = "MEMREGSC22";
    CPAFLPMembershipTierSkus["ENROLLMENT_FEE"] = "MEMFEE01";
})(CPAFLPMembershipTierSkus = exports.CPAFLPMembershipTierSkus || (exports.CPAFLPMembershipTierSkus = {}));
var MembershipEnrollmentFeeSku;
(function (MembershipEnrollmentFeeSku) {
    MembershipEnrollmentFeeSku["AICPA_MEMBERSHIP_ENROLLMENT_FEE_SKU"] = "CIMAMEMENRFEE22";
    MembershipEnrollmentFeeSku["CIMA_MEMBERSHIP_ENROLLMENT_FEE_SKU"] = "MEMFEE01";
})(MembershipEnrollmentFeeSku = exports.MembershipEnrollmentFeeSku || (exports.MembershipEnrollmentFeeSku = {}));
var DonationsSlug;
(function (DonationsSlug) {
    DonationsSlug["CIMA_BENEVOLENT_FUND"] = "cima-benevolent-fund";
})(DonationsSlug = exports.DonationsSlug || (exports.DonationsSlug = {}));
//# sourceMappingURL=index.js.map